import { render, staticRenderFns } from "./CompareFilter.vue?vue&type=template&id=2966722f&scoped=true&"
import script from "./CompareFilter.vue?vue&type=script&lang=js&"
export * from "./CompareFilter.vue?vue&type=script&lang=js&"
import style0 from "./CompareFilter.vue?vue&type=style&index=0&id=2966722f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966722f",
  null
  
)

export default component.exports